export const MAP_ZOOM = 10.5;
export const FLIGHT_ZOOM = 5;
